import { Component } from '@angular/core';

import { NavbarComponent } from './navbar.component';

@Component({
  selector: 'app-navbar-desktop',
  templateUrl: './navbar-desktop.component.html',
  standalone: false
})
export class NavbarDesktopComponent extends NavbarComponent {}
